import { c as _c } from "react/compiler-runtime";
import { useMemo } from "react";
import useLocalStorage from "hooks/useLocalStorage";
import { getPreferredStopName, getStoredStopId, hasFavouriteStopId } from "@catchy/app-core";
import { getStorageKey } from "@/lib/regions/client";
import StopRow from "./StopRow";
import StopMarker from "@catchy/assets/svgs/stop-mono-lg.svg";
import Star from "@catchy/assets/svgs/star.svg";
const Recents = t0 => {
  const $ = _c(25);
  const {
    className: t1,
    emptyMessage: t2,
    isClient,
    isLoading,
    preferredStopNames,
    showHeading: t3,
    showWhenEmpty: t4,
    stops,
    onStopSelect,
    title: t5,
    type
  } = t0;
  const className = t1 === undefined ? "" : t1;
  const emptyMessage = t2 === undefined ? "Your recently viewed stops will show up here." : t2;
  const showHeading = t3 === undefined ? true : t3;
  const showWhenEmpty = t4 === undefined ? false : t4;
  const title = t5 === undefined ? "Recently Viewed" : t5;
  let t6;
  let t7;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = getStorageKey("favourites");
    t7 = [];
    $[0] = t6;
    $[1] = t7;
  } else {
    t6 = $[0];
    t7 = $[1];
  }
  const [favourites] = useLocalStorage(t6, t7);
  let t8;
  let t9;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = getStorageKey("recents");
    t9 = [];
    $[2] = t8;
    $[3] = t9;
  } else {
    t8 = $[2];
    t9 = $[3];
  }
  const [recents] = useLocalStorage(t8, t9);
  let t10;
  if ($[4] !== preferredStopNames || $[5] !== recents || $[6] !== stops) {
    const list = Array.isArray(recents) ? recents : [];
    let t11;
    if ($[8] !== stops) {
      t11 = rec => stops?.some(stop => stop.stop_id === getStoredStopId(rec));
      $[8] = stops;
      $[9] = t11;
    } else {
      t11 = $[9];
    }
    const filtered = list.filter(t11);
    filtered.sort(_temp);
    let t12;
    if ($[10] !== preferredStopNames || $[11] !== stops) {
      t12 = rec_0 => {
        const stop_id = getStoredStopId(rec_0);
        const preferredName = getPreferredStopName(preferredStopNames, stop_id, stop_id);
        const stop_name = preferredName || stops?.find(stop_0 => stop_0.stop_id === stop_id)?.stop_name;
        const stop_type = stops?.find(stop_1 => stop_1.stop_id === stop_id)?.stop_type;
        return {
          stop_id,
          stop_name,
          stop_type,
          timestamp: rec_0.timestamp
        };
      };
      $[10] = preferredStopNames;
      $[11] = stops;
      $[12] = t12;
    } else {
      t12 = $[12];
    }
    t10 = filtered.map(t12);
    $[4] = preferredStopNames;
    $[5] = recents;
    $[6] = stops;
    $[7] = t10;
  } else {
    t10 = $[7];
  }
  const typeRecents = t10;
  let t11;
  if ($[13] !== className || $[14] !== emptyMessage || $[15] !== favourites || $[16] !== isClient || $[17] !== isLoading || $[18] !== onStopSelect || $[19] !== showHeading || $[20] !== showWhenEmpty || $[21] !== title || $[22] !== type || $[23] !== typeRecents) {
    t11 = isClient && (typeRecents.length > 0 || showWhenEmpty) ? <section className={`flex flex-col ${className}`.trim()}>{showHeading ? <div className="mb-2 flex justify-between px-[20px]"><h2 className="text-3xl font-semibold">{title}</h2></div> : null}{isLoading ? <div className="mx-[20px] flex justify-start py-4"><div className="grid h-6 w-11 shrink-0 place-items-center pt-1"><Star className="h-5 w-5 text-zinc-400 opacity-50" /></div><aside className="text-pretty pt-1 text-lg leading-tight opacity-80">Loading recents…</aside></div> : isClient && (typeRecents.length ? <div className="flex flex-col">{typeRecents.slice(0, 5).map(stop_2 => <StopRow stop_id={stop_2.stop_id} stop_name={stop_2.stop_name} stop_type={stop_2.stop_type} type={type} isFavourite={hasFavouriteStopId(favourites, stop_2.stop_id)} key={stop_2.stop_id} onStopSelect={typeof onStopSelect === "function" ? () => onStopSelect(stop_2) : undefined} />)}</div> : <div className="mx-[20px] flex justify-start py-4"><div className="grid h-6 w-11 shrink-0 place-items-center pt-1"><StopMarker className="mt-0.5 h-[1.125rem] w-3 flex-shrink-0 text-zinc-400 opacity-50" /></div><aside className="text-pretty pt-1 text-lg leading-tight opacity-80">{emptyMessage}</aside></div>)}</section> : null;
    $[13] = className;
    $[14] = emptyMessage;
    $[15] = favourites;
    $[16] = isClient;
    $[17] = isLoading;
    $[18] = onStopSelect;
    $[19] = showHeading;
    $[20] = showWhenEmpty;
    $[21] = title;
    $[22] = type;
    $[23] = typeRecents;
    $[24] = t11;
  } else {
    t11 = $[24];
  }
  return t11;
};
export default Recents;
function _temp(a, b) {
  return (b?.timestamp || "").localeCompare(a?.timestamp || "");
}